import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
//import { WebStorageService } from '../_core/services';
//import { LoaderService } from './loader.service'
import { environment } from '@environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WindowsWrapper } from '../../app.config';

import { Utils } from '../helper/Utils';
import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
import { of } from 'rxjs';
import { DialerService } from './dialer.service';
@Injectable({
  providedIn: 'root',
})
export class TmQueueService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService,
    private dialerService: DialerService,
      private utils: Utils,
      @Inject(WindowsWrapper) private OnvidaWrapper: any
  ) { 
    }
    public Transfer_SUBMIT_CALL = new BehaviorSubject<any>(null);
    public Trigger_saveChanges = new BehaviorSubject<any>(null);
    public CallTransfer_internalCallInProgress = new BehaviorSubject<any>(null);
    public CallTransfer_internalCallEnded = new BehaviorSubject<any>(null);
    public CallTransfer_hide = new Subject<any>();
    //public CallTransfer_TransferController_CLOSE = new BehaviorSubject<any>(null);
    public CallTransfer_callerHungUp = new BehaviorSubject<any>(null);
    public showdialerstatusmenu = new BehaviorSubject<any>(null);
    public startOutboundCall = new BehaviorSubject<any>(null);
    public CallTransfer_Reset = new BehaviorSubject<any>(null);
    isTopMenuQueueSelected: boolean = false;
    isQueueTaskMenuLoaded: boolean = false;
    isBlendedQueue: boolean = false;
    isBlendedQueueAvailable: boolean = false;
    //isCallConnected: boolean = false;
    WrapperOnvida: any;
    currentQueueData : any;
    handleError(errorResponse: HttpErrorResponse) {
    this?.dialerService?.setIsBlockLoader(false);
    return Utils.handleHttpError(errorResponse);
  }

  getQueues(): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetQueues`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
       // console.log(res)
        const itemsToRemove = ['TextChat']; 
          res.Response.Data = res.Response.Data.filter(item => !itemsToRemove.includes(item.Type));
          this.currentQueueData = res;
        return res;
      }),
      catchError(this.handleError.bind(this))
    );
  }

  getOptionsForQueue(selectedQueueId: any): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company, queueID: selectedQueueId };

   // console.log('getOptionsForQueue', uc);
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetOptionsForQueue`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(this.handleError.bind(this))
    );
  }

  getQueueInfo(selectedQueueId: any): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company, queueID: selectedQueueId };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetQueueInfo`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(this.handleError.bind(this))
    );
  }

  GetTwilioToken(): any {
      const pl: any = { phoneClient: 'Twilio', ttl: 28800 };

    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetSipCredentials`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
    }
    GetClientTokenUpdate(): any {
        const pl: any = { phoneClient: 'Twilio', ttl: 28800 };

        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/data/GetClientToken`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

  startCall(phoneNo: string, queueID: any): any {
    const pl: any = {
      number: phoneNo,
      requestType: null,
      requestTypeColor: null,
      unknownCallee: false,
      isPersonalCall: false,
        queueID: queueID,
        company: this.webStorageService.getItemFromSessionStorage('company')
    };
    //{"number":"9902897172","requestType":null,"requestTypeColor":null,"csrfCookie":"D93889FB3B2FE8B77B713D7A9FB43C35101F8ABF"}
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/StartCall`, pl).pipe(
      map(res => {
        this.loaderService.display(false);

        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  waitingForCall(queueID: number, agentCallID: string): any {
    const pl: any = {};

    const interactionModel: any = {
      queueID: queueID,
      agentCallID: agentCallID,
    };
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    pl.interactionModel = interactionModel;

    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/WaitingForCall`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

    GetGroupTransferStatus(agentCallID: string): any {
        const pl: any = {};

        //const interactionModel: any = {
        //    queueID: queueID,
        //    agentCallID: agentCallID,
        //};
        pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
        pl.company = this.webStorageService.getItemFromSessionStorage('company');
        //pl.interactionModel = interactionModel;
        pl.callID = agentCallID;

        // // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/interaction/GetGroupTransferStatus`, pl).pipe(
            map(res => {
                // this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

    CallTransfer(params: any, methodName: string): any {
        const pl: any = {};

        const interactionModel: any = {
            userID: params.userID,
            enterRecordTime: params.enterRecordTime,
            callID: params.callID,
        };
        if (methodName == 'StartGroupTransfer') {
            interactionModel.blind = params.blind;
            interactionModel.transferType = params.transferType;
            interactionModel.transferGroupID = params.transferGroupID;
        }
        if (methodName == 'CompleteGroupTransfer') {
            interactionModel.attended = params.attended;

        }
        pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
        pl.company = this.webStorageService.getItemFromSessionStorage('company');
        pl.interactionModel = interactionModel;
        pl.callID = params.callID;
        pl.skipCheck = false;
        pl.isInbound = true;
        if (methodName == 'CompleteGroupTransfer') {
            pl.groupInteractionid = params.groupInteractionid;

        }
        if (methodName != 'AddUserToCall') {
            pl.number = params.number;
            pl.isInternal = !params.isExternal;
        }

        // // this.loaderService.display(true);
        const apiurl = 'api/interaction/' + methodName;
        return this.http.post<any>(`${environment.apiUrl}` + apiurl, pl).pipe(
            map(res => {
                 this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

  GetInternalCallInfo(conferenceID: string, callID: string): any {
    const pl: any = {};

    //const interactionModel: any = {

    //    userID: params.userID,
    //    enterRecordTime: params.enterRecordTime,
    //    callID: params.callID
    //};
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');

    pl.callID = callID;
    pl.conferenceID = conferenceID;
    // pl.skipCheck = false;
    //pl.isInbound = true;
    // // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/interaction/GetInternalCallInfo`, pl).pipe(
      map(res => {
        // this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  IsTransferCancelled(userID: string, interactionID: string): any {
    const pl: any = {};

    //const interactionModel: any = {

    //    userID: params.userID,
    //    enterRecordTime: params.enterRecordTime,
    //    callID: params.callID
    //};
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');

    pl.userID = userID;
    pl.interactionID = interactionID;
    // pl.skipCheck = false;
    //pl.isInbound = true;
    // // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/interaction/IsTransferCancelled`, pl).pipe(
      map(res => {
        // this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

    CancelCall(agentChatDisconnected, callID, GroupTransferInteractionID): any {
        const pl: any = {};
        const interactionModel: any = {
            agentChatDisconnected: agentChatDisconnected,
            callID: callID
        };

        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;
        pl.callId = callID;
        pl.interactionModel = interactionModel;
        
        pl.groupInteractionid= GroupTransferInteractionID;
        return this.http.post<any>(`${environment.apiUrl}api/interaction/CancelCall`, pl).pipe(
            map(res => {
              this.loaderService.display(false);
              // console.log(res);
              return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

    CancelAttendedTransferAgentCall(callID): any {
        const pl: any = {};
        const interactionModel: any = {
            
            callID: callID
        };

        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;
        pl.callId = callID;
        pl.interactionModel = interactionModel;

     
        return this.http.post<any>(`${environment.apiUrl}api/interaction/CancelAttendedTransferAgentCall`, pl).pipe(
            map(res => {
              this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

  ResumeCall(callID: string, cancelTransfer: boolean, isGroupTransfer: boolean): any {
    const pl: any = {};

    //const interactionModel: any = {

    //    userID: params.userID,
    //    enterRecordTime: params.enterRecordTime,
    //    callID: params.callID
    //};
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');

    pl.callID = callID;
    pl.cancelTransfer = cancelTransfer;
    pl.isGroupTransfer = isGroupTransfer;
    // pl.skipCheck = false;
    //pl.isInbound = true;
    // // this.loaderService.display(true);

    return this.http.post<any>(`${environment.apiUrl}api/interaction/ResumeCall`, pl).pipe(
      map(res => {
         this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  CallTransferred(callID: string, queueID: string,isFreeDialer:boolean): any {
    const pl: any = {};

    pl.callID = callID;
    pl.queueID = queueID;
    pl.userData = {};
    pl.disposition = '';
    //pl.notes = '';
    pl.isFreeDialer = isFreeDialer;
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    //pl.interactionModel = interactionModel;

    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/registration/CallTransferred`, pl).pipe(
      map(res => {
         this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  CompleteAddCaller(callID: string, queueID: string): any {
    const pl: any = {};

    pl.callID = callID;
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    //pl.interactionModel = interactionModel;

    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/CompleteAddCaller`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  CompleteAttendedTransfer(callID: string, userid: string): any {
    const pl: any = {};

    const interactionModel: any = {
      userID: userid,
      enterRecordTime: null,
      callID: callID,
    };
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    pl.interactionModel = interactionModel;
    pl.callID = callID;
    pl.skipCheck = false;
    pl.isInbound = true;
    //pl.number = params.number;

    pl.callID = callID;
    pl.userid = userid;
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    //pl.interactionModel = interactionModel;

    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/CompleteAttendedTransfer`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getAgentStatuses(): any {
    const pl: any = {};

    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    //pl.interactionModel = interactionModel;

    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/GetAgentStatuses`, pl).pipe(
      map(res => {
        // this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
    }

    getAgentGroupStatuses(selectedQueueId: any): any {
        //const pl: any = {};

        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        const uc = { user: user, company: company, queueID: selectedQueueId };
        //pl.interactionModel = interactionModel;

        // // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/Data/GetTransferGroups`, uc).pipe(
            map(res => {
                // this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }
  isInboundCallConnected(): any {
    const pl: any = { isExternalSystem: false };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    //  // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/IsInboundCallConnected`, pl).pipe(
      map(res => {
        //  this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getInboundStatus(queueID: number, showLoader: boolean): any {
    const pl: any = { queueID: queueID };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    //if (showLoader)
      // this.loaderService.display(true);
      return this.http.post<any>(`${environment.apiUrl}api/service/data/GetInboundStatus`, pl).pipe(
        map(res => {
          //this.loaderService.display(false);
          // console.log(res);
          return res;
        }),
        catchError(this.handleError)
        //this.handleError
      );
  }

    getUpdate(callId: any, groupInteractionid: any): any {
        const pl: any = { callId: callId, groupInteractionid: groupInteractionid };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    return this.http.post<any>(`${environment.apiUrl}api/interaction/GetUpdate`, pl).pipe(
      map(res => {
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
    Disconnect(callId: any, groupInteractionid: any): any {
        const pl: any = { callId: callId, groupInteractionid: groupInteractionid };
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;
        return this.http.post<any>(`${environment.apiUrl}api/interaction/Disconnect`, pl).pipe(
            map(res => {
              this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }
  setUserStatus(statusID, queueID) {
    //let param = {appClientType: "Browser", queueID: 4883, statusID:6}
      const pl: any = { appClientType: this.OnvidaWrapper.IsWrapper == true ? "WindowsWrapper" : "Browser" };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    pl.statusID = statusID;
    pl.queueID = queueID;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/SetUserStatus`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  setCurrentQueue(queueID: number): any {
    const pl: any = { id: queueID };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/SetCurrentQueue`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  releaseLocks(): any {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    if (!user || !company) {
      //console.log('releaseLocks skipped: missing user or company info');
      return of(null);
    }
    return this.http.post<any>(`${environment.apiUrl}api/service/data/releaseLocks`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getExternalNumbersByActivity(queueID: number) {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    pl.queueID = queueID;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/GetExternalNumbersByActivity`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  setCurrentActionItem(queueId, ActionItemID) {
    const pl: any = { queueID: queueId, id: ActionItemID };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/SetCurrentActionItem`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  GetNextActionItem(queueId) {
      const pl: any = { queueID: queueId };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetNextActionItem`, pl).pipe(
      map(res => {
         this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  getFailureDispositions() {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetFailureDispositions`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getUserStatus(queueId) {
    const pl: any = { queueID: queueId };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetUserStatus`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getVoicemailCountByStatus(agentID, status) {
    const pl: any = { agentID: agentID, status: status };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/manager/GetVoicemailCountByStatus`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }
  getAgent(userID:any) {
    const pl: any = {};
    pl.userID = userID;
    pl.company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetAgent`,pl).pipe(
      map(res => {
        return res;
      }),
      catchError(this.handleError)
    );
  }
  callStatusChanged() {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/dailer/CallStatusChanged`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  twilioInbound() {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/dailer/TwilioInbound`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  callEnded() {
    const pl: any = {};
    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/dailer/callEnded`, {}).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getQueueColumns(queueId) {
    const pl: any = { queueID: queueId };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data//GetQueueColumns`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getInboundCalls(queueId, showLoader: boolean) {
    const pl: any = { queueID: queueId };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    if (showLoader) {
      // this.loaderService.display(true);
    }
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetInboundCalls`, pl).pipe(
      map(res => {
        //this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  answerInboundCall(callId, queueId) {
    const pl: any = { callID: callId, queueID: queueId };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/AnswerInboundCall`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  findRecord(type, value) {
    const pl: any = { Type: type, Value: value, agentsOnly: false };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/FindRecord`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  setCurrentCallee(callID,userID) {
    const pl: any = { callID: callID };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    pl.id = (userID>=0?userID:user.UserID);

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/SetCurrentCallee`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  holdCall(callID, isInbound) {
    const pl: any = { callID: callID, skipCheck: false, isInbound: isInbound };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    //pl.user = user;
    pl.company = company;
    //pl.id = user.UserID;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/Hold`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

    ToggleLines(callID, queueID, transferCallID, talkToTransfer, GroupTransferInteractionID) {
    const pl: any = {
      callID: callID,
      queueID: queueID,
      InternalCallID: transferCallID,
        talkToTransfer: talkToTransfer,
       GroupTransferInteractionID: GroupTransferInteractionID
    };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.company = company;
    //pl.id = user.UserID;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/ToggleLines`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

   resumeCall(callID, isInbound, cancelTransfer, groupInteractionid) {
        const pl: any = { callID: callID, isInbound: isInbound, cancelTransfer: cancelTransfer, groupInteractionid: groupInteractionid };
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        //pl.user = user;
        pl.company = company;
        //pl.id = user.UserID;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/interaction/ResumeCall`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }

  updateRelatedCalls(parentCallID) {
      const pl: any = { parentCallID: parentCallID };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.company = company;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/registration/UpdateRelatedCalls`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
    }
    SubmitRelatedCall(activityId, queueId, callId, callDuration, phoneNumber, contactName, parentCallID, parentUserID) {
        const pl: any = { parentCallID: parentCallID, activityId: activityId, queueId: queueId, callId: callId, callDuration: callDuration, phoneNumber: phoneNumber, contactName: contactName, parentUserID: parentUserID };
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.company = company;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/registration/SubmitRelatedCall`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError)
            //this.handleError
        );
    }
  setUserDetails() {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.grantName = 'test';
    pl.company = company;
    return pl;
  }
  getStatusDetails() {
    let pl: any = {};
    pl = this.setUserDetails();

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetCustomStatuses`, pl).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(this.handleError.bind(this))
    );
  }

  rejectCall(agentCallID: string): any {
    const pl: any = { isExternalSystem: false };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    //let interactionModel: any = {"callID": agentCallID }
    pl.user = user;
    pl.company = company;
    pl.callID = agentCallID;
    // // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/interaction/RejectCall`, pl).pipe(
      map(res => {
        // this.loaderService.display(false);
        // console.log(res);
        return res;
      }),
      catchError(this.handleError)
      //this.handleError
    );
  }

  getisTopMenuQueueSelected() {
    return this.isTopMenuQueueSelected;
  }
  setisTopMenuQueueSelected(value) {
    this.isTopMenuQueueSelected = value;
  }

  getisQueueTaskMenuLoaded() {
    return this.isQueueTaskMenuLoaded;
  }
  setisQueueTaskMenuLoaded(value) {
    this.isQueueTaskMenuLoaded = value;
    } 
    // getisCallConnected() {
    //     return this.isCallConnected;
    // }
    // setisCallConnected(value) {
    //     console.log('setiscallconnected' + value);
    //     this.isCallConnected = value;
    // }

    setTransfer_SUBMIT_CALL(value: any) {
        this.Transfer_SUBMIT_CALL.next(value);
    }
    setTrigger_saveChanges(value: any) {
        this.Trigger_saveChanges.next(value);
    }
    setCallTransfer_internalCallInProgress(value: any) {
        this.CallTransfer_internalCallInProgress.next(value);
    }
    setCallTransfer_Reset(value: any) {
        this.CallTransfer_Reset.next(value);
    }
    setCallTransfer_internalCallEnded(value: any) {
        this.CallTransfer_internalCallEnded.next(value);
    }
    setCallTransfer_hide(value: any) {
        this.CallTransfer_hide.next(value);
    }
    //setCallTransfer_TransferController_CLOSE(value: any) {
    //    this.CallTransfer_TransferController_CLOSE.next(value);
    //}
    setCallTransfer_callerHungUp(value: any) {
        this.CallTransfer_callerHungUp.next(value);
    }
    setshowdialerstatusmenu(value: any) {
        this.showdialerstatusmenu.next(value);
    }
    setstartOutboundCall(value: any) {
        this.startOutboundCall.next(value);
    }
    getisBlendedQueue() {
        return this.isBlendedQueue;
    }
    setisBlendedQueue(value) {
        this.isBlendedQueue = value;
    }
    getisBlendedQueueAvailable() {
        return this.isBlendedQueueAvailable;
    }
    setisBlendedQueueAvailable(value) {
        this.isBlendedQueueAvailable = value;
    }
    getcurrentQueueData() {
        return this.currentQueueData;
    }
    setcurrentQueueData(value) {
        this.currentQueueData = value;
    }
    
    submitFailure(callID: string, disposition: number, activityID: string, notes: string, selectedUserID: string, enterRecord: any, interactionID:any): any {
        const pl: any = {
            callID: callID,
            disposition: disposition,
            activityID: activityID,
            notes: notes,
            calleeUserId: selectedUserID,
            enterRecord: enterRecord,
            interactionID: interactionID
        };
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/registration/SubmitFailure`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(this.handleError.bind(this))
        );
    }

    getEmailDetails(emailId: any){
      //Emaildetails/GetEmailDetails
      const pl: any = { emailId: emailId };
      const user = this.webStorageService.getItemFromSessionStorage('currentUser');
      const company = this.webStorageService.getItemFromSessionStorage('company');
      pl.user = user;
      pl.company = company;

      // this.loaderService.display(true);
      return this.http.post<any>(`${environment.apiUrl}api/Emaildetails/GetEmailDetails`, pl).pipe(
        map(res => {
          this.loaderService.display(false);
          // console.log(res);
          return res;
        }),
        catchError(this.handleError)
        //this.handleError
      );
    }
}
